import { render, staticRenderFns } from "./List.vue?vue&type=template&id=8e3d310e&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=8e3d310e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3d310e",
  null
  
)

export default component.exports